import {
  createSelector
} from 'reselect';
import _ from 'lodash';

import itemTypePluralize from '../../components/common/itemTypePluralrize';
import {
  TransactionType
} from '../../config/constants';

const transactions = state => state.transactions.entries;
const summaryData = state => state.transactions.summaryData;

export const getSales = createSelector(transactions, txs =>
  txs.filter(t => t.transactionType === TransactionType.DISPOSED));

export const getAcquisitions = createSelector(transactions, (txs) => {
  return txs.filter(t => t.transactionType === TransactionType.ACQUIRED);
});

export const getSortedSummaryData = createSelector(summaryData, (sd) => {
  return _.sortBy(sd.subcatLevel, ['cat', 'attributeValue']);
});

export const getSummaryChartData = createSelector(summaryData, (sd) => {
  let total = 0;
  sd.catLevel.forEach((c) => {
    total += c.averageValue;
  });

  return sd.catLevel.map(c => ({
    category: itemTypePluralize(c.cat),
    [`${c.cat.toLowerCase()}AvgMarketValue`]: c.averageValue,
    percentage: Math.round((c.averageValue / total) * 100),
  }));
});

export const getSummaryPieChartData = createSelector(summaryData, (sd) => {
  let total = 0;
  sd.catLevel.forEach((c) => {
    total += c.totalValue;
  });

  return sd.catLevel.map(c => ({
    id: c.cat,
    label: itemTypePluralize(c.cat),
    value: c.totalValue,
    percentage: Math.round((c.totalValue / total) * 100),
  }));
});

export const getItemCountChartData = createSelector(summaryData, (sd) => {
  let total = 0;
  sd.catLevel.forEach((c) => {
    total += c.count;
  });

  return sd.catLevel.map(c => ({
    id: c.cat,
    label: itemTypePluralize(c.cat),
    value: c.count,
    percentage: Math.round((c.count / total) * 100),
  }));
});

export const getCollectionTimelineChartData = createSelector(transactions, (txs) => {
  const preparedData = _.sortBy(txs, ['transactionDate']).reduce(
    (accum, value, index, sortedData) => {
      if (
        index > 0 &&
        value.transactionDate.getTime() === sortedData[index - 1].transactionDate.getTime()
      ) {
        return accum;
      }
      accum.push({
        x: value.transactionDate,
        y: parseFloat(value.cumulativeTotal),
      });
      return accum;
    },
    []
  );

  return {
    series: [{
      name: 'timeline-data',
      data: preparedData,
    }, ],
  };
});

export const getDashboardStats = createSelector([transactions, summaryData], (txs, sd) => {
  return {
    totalItemCount: sd.catLevel.reduce((prev, curr) => prev + curr.count, 0),
    marketValue: _.last(txs) ? _.last(txs).cumulativeTotal : 0,
    averageValue: sd.subcatLevel.length > 0 ?
      _.sumBy(sd.subcatLevel, 'averageValue') / sd.subcatLevel.length : 0,
    gainLoss: _.sumBy(sd.catLevel, 'gain'),
    totalPurchasePrice: _.sumBy(sd.catLevel, 'totalPurchasePrice'),
  };
});


// WEBPACK FOOTER //
// ./src/redux/selectors/transactions.js